// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IPDTeam_wrapper__cmt88 {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  gap: 32px;
}
.IPDTeam_djelatnici-grid__P-bbo {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 90%;
  margin-top: -32px;
}
.IPDTeam_djelatnici-card__gxRoM {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
  box-sizing: border-box;
}
.IPDTeam_djelatnici-card__gxRoM img {
  max-width: 100%;
  height: auto;
}
.IPDTeam_title__wqswk {
  font-size: 40px;
  line-height: 48px;
  color: #4d4d4d;
}
.IPDTeam_title__wqswk,
.IPDTeam_subtitle__FYd7h {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
}
.IPDTeam_subtitle__FYd7h {
  font-size: 28px;
  line-height: 34px;
  color: #4d4e4e;
}
.IPDTeam_UserMenu__CGAei {
  display: flex;
  gap: 10px;
}
.IPDTeam_dropdownMoreOptionsRow__99GRG {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.IPDTeam_tabContainer__ZOpls {
  display: flex;
  justify-content: space-between;
  width: 90%;
}

.IPDTeam_link__B1tar {
  text-decoration: none;
  display: contents;
}
.IPDTeam_titleForAddToGroup__yO1gl {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
}
.IPDTeam_ContainerTitleGroups__Ars4z {
  margin-top: 50px;
  margin-bottom: 30px;
}
.IPDTeam_btnRow__VWnUB {
  position: fixed;
  bottom: 20px;
  left: 0px;
  width: 100%;
  gap: 16px;
  z-index: 100;
}
.IPDTeam_btnRow__VWnUB,
.IPDTeam_declineBtn__EdMQP,
.IPDTeam_saveBtn__gyxG\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.IPDTeam_declineBtn__EdMQP,
.IPDTeam_saveBtn__gyxG\\+ {
  width: 20%;
  border-radius: 4px;
  column-gap: 8px;
  display: flex;
  height: 52px;
  width: 228px;
  cursor: pointer;
  border: none;
  text-align: center;
  transition: background-color 300ms ease-in-out;
}
.IPDTeam_declineBtn__EdMQP,
.IPDTeam_saveBtn__gyxG\\+,
.IPDTeam_emptySpan__pbWtY {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.IPDTeam_saveBtn__gyxG\\+ {
  background-color: #cb9c2d;
  color: white;
}
.IPDTeam_saveBtn__gyxG\\+:hover {
  background-color: #b68c29;
}
.IPDTeam_declineBtn__EdMQP {
  background-color: #ebebeb;
  color: #808080;
}
.IPDTeam_declineBtn__EdMQP:hover {
  background-color: #b9b9b9;
}
.IPDTeam_emptyContainer__kLJc2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 32px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  background-color: #fcfcfc;
  box-sizing: border-box;
}
.IPDTeam_emptySpan__pbWtY {
  text-align: left;
  color: #5f6d7e;
}

@media screen and (max-width: 420px) {
  .IPDTeam_emptyContainer__kLJc2 {
    padding: 13px;
  }
}

@media screen and (max-width: 1550px) {
  .IPDTeam_djelatnici-grid__P-bbo {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 1000px) {
  .IPDTeam_djelatnici-grid__P-bbo {
    grid-template-columns: repeat(2, 1fr);
  }
  .IPDTeam_tabContainer__ZOpls {
    flex-direction: column;
    width: 83%;
  }
}

@media screen and (max-width: 680px) {
  .IPDTeam_tabContainer__ZOpls {
    flex-direction: column;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/IPDTeam/IPDTeam.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,WAAW;EACX,SAAS;EACT,YAAY;AACd;AACA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  width: 100%;\n  gap: 32px;\n}\n.djelatnici-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  width: 90%;\n  margin-top: -32px;\n}\n.djelatnici-card {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: center;\n  box-sizing: border-box;\n}\n.djelatnici-card img {\n  max-width: 100%;\n  height: auto;\n}\n.title {\n  font-size: 40px;\n  line-height: 48px;\n  color: #4d4d4d;\n}\n.title,\n.subtitle {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.subtitle {\n  font-size: 28px;\n  line-height: 34px;\n  color: #4d4e4e;\n}\n.UserMenu {\n  display: flex;\n  gap: 10px;\n}\n.dropdownMoreOptionsRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n.tabContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 90%;\n}\n\n.link {\n  text-decoration: none;\n  display: contents;\n}\n.titleForAddToGroup {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n}\n.ContainerTitleGroups {\n  margin-top: 50px;\n  margin-bottom: 30px;\n}\n.btnRow {\n  position: fixed;\n  bottom: 20px;\n  left: 0px;\n  width: 100%;\n  gap: 16px;\n  z-index: 100;\n}\n.btnRow,\n.declineBtn,\n.saveBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.declineBtn,\n.saveBtn {\n  width: 20%;\n  border-radius: 4px;\n  column-gap: 8px;\n  display: flex;\n  height: 52px;\n  width: 228px;\n  cursor: pointer;\n  border: none;\n  text-align: center;\n  transition: background-color 300ms ease-in-out;\n}\n.declineBtn,\n.saveBtn,\n.emptySpan {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.saveBtn {\n  background-color: #cb9c2d;\n  color: white;\n}\n.saveBtn:hover {\n  background-color: #b68c29;\n}\n.declineBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.declineBtn:hover {\n  background-color: #b9b9b9;\n}\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  padding: 32px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  background-color: #fcfcfc;\n  box-sizing: border-box;\n}\n.emptySpan {\n  text-align: left;\n  color: #5f6d7e;\n}\n\n@media screen and (max-width: 420px) {\n  .emptyContainer {\n    padding: 13px;\n  }\n}\n\n@media screen and (max-width: 1550px) {\n  .djelatnici-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .djelatnici-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .tabContainer {\n    flex-direction: column;\n    width: 83%;\n  }\n}\n\n@media screen and (max-width: 680px) {\n  .tabContainer {\n    flex-direction: column;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `IPDTeam_wrapper__cmt88`,
	"djelatnici-grid": `IPDTeam_djelatnici-grid__P-bbo`,
	"djelatnici-card": `IPDTeam_djelatnici-card__gxRoM`,
	"title": `IPDTeam_title__wqswk`,
	"subtitle": `IPDTeam_subtitle__FYd7h`,
	"UserMenu": `IPDTeam_UserMenu__CGAei`,
	"dropdownMoreOptionsRow": `IPDTeam_dropdownMoreOptionsRow__99GRG`,
	"tabContainer": `IPDTeam_tabContainer__ZOpls`,
	"link": `IPDTeam_link__B1tar`,
	"titleForAddToGroup": `IPDTeam_titleForAddToGroup__yO1gl`,
	"ContainerTitleGroups": `IPDTeam_ContainerTitleGroups__Ars4z`,
	"btnRow": `IPDTeam_btnRow__VWnUB`,
	"declineBtn": `IPDTeam_declineBtn__EdMQP`,
	"saveBtn": `IPDTeam_saveBtn__gyxG+`,
	"emptySpan": `IPDTeam_emptySpan__pbWtY`,
	"emptyContainer": `IPDTeam_emptyContainer__kLJc2`
};
export default ___CSS_LOADER_EXPORT___;
